import common from './common';
import navigate from './navigate';
import databaseTableMappings from './databaseTableMappings';
export default {
  common,
  navigate,
  databaseTableMappings
};
